<template>
  
<div class="row">
  <div class="col-12 col-lg-6 engineering-paper">
    <h5 class="card-title">NBCC 2015</h5>
    <ul>
      <li>
        <RouterLink to="/snow-load" class="nav-link sublink">Snow Load</RouterLink>
        <span class="mx-3 fst-italic">4.1.6. Loads Due to Snow and Rain</span>
      </li>
      <li>
        <RouterLink to="/wind-load-static-low" class="nav-link sublink">Wind Load</RouterLink>
        <span class="mx-3 fst-italic">4.1.7.3. Static Procedure for Low Buildings (H≤20m) 4.1.7.6.</span>
      </li>
      <li>
        <RouterLink to="/wind-load-static-tall" class="nav-link sublink">Wind Load</RouterLink>
        <span class="mx-3 fst-italic">4.1.7.3. Static Procedure for Tall Buildings (H>20m) 4.1.7.5.</span>
      </li>
      <li>
        <RouterLink to="" class="nav-link sublink">Wind Load</RouterLink>
        <span class="mx-3 fst-italic">4.1.7.8. Dynamic Procedure</span>
      </li>
    </ul>

    <h5 class="card-title">CSA O86-19</h5>
    <ul>
      <li>
        <RouterLink to="/lag-screw-withdrawal" class="nav-link sublink">Lag Screw Withdrawal</RouterLink>
      </li>
      <li>
        <RouterLink to="/bending-shear" class="nav-link sublink">Bending Shear</RouterLink>
      </li>
    </ul>

    <h5 class="card-title">CSA S16-19</h5>
    <ul>
      <li>
        <RouterLink to="/steel-column" class="nav-link sublink">Steel Column</RouterLink>
      </li>
    </ul>

    <h5 class="card-title">CSA A23.3-24</h5>
    <ul>
      <li>
        <RouterLink to="/foundation-wall" class="nav-link sublink">Foundation Wall</RouterLink>
      </li>
      <li>
        <RouterLink to="/concrete-beam" class="nav-link sublink">Concrete Beam</RouterLink>
      </li>
      <li>
        <RouterLink to="/punching-shear" class="nav-link sublink">Punching Shear</RouterLink>
      </li>
    </ul>

    <h5 class="card-title">ASCE 7-16</h5>
    <ul>
      <li>
        <RouterLink to="/ASCE7-16/snow-load" class="nav-link sublink">Snow Load</RouterLink>
        <span class="mx-3 fst-italic">7.3 & 7.4. Flat and Sloped Roof Snow Loads</span>
      </li>
    </ul>

    <h5 class="card-title">AISC Design Guide 11</h5>
    <ul>
      <li>
        <RouterLink to="/stair-vibration" class="nav-link sublink">Stair Vibration</RouterLink>
      </li>
    </ul>

    <h5><RouterLink to="/about" class="nav-link sublink">About</RouterLink><span class="mx-3 fst-italic">Visit this page if you wanna now about me!</span></h5>
    
  </div>
  <div class="col-12 col-lg-6 engineering-paper">
    <!-- <Visualizer :descriptor="[
        { type: 'rect', x: 50, y: 50, width: 200, height: 100, fill: 'transparent', stroke: 'black' },
        { type: 'circle', cx: 150, cy: 100, r: 30, fill: 'transparent', stroke: 'black' },
        { type: 'text', x: 150, y: 30, text: 'CalcPad', fontSize: 24, fill: 'black', textAnchor: 'middle' },
        { type: 'text', x: 150, y: 180, text: 'Engineering Calculator', fontSize: 16, fill: 'black', textAnchor: 'middle' }
      ]" :width="300" :height="200" /> -->
    <MohrCircle />
  </div>
</div>

</template>

<script>
// import Visualizer from './components/Visualizer.vue';
import MohrCircle from './components/MohrCircle.vue';

export default {
  name: 'HomePage',
  components: {
    // Visualizer,
    MohrCircle
  },
}
</script>

<style scoped>
  span{
    font-size: 0.8rem;
  }
  
  .sublink {
    text-decoration: none;
    color: black;
    border-bottom: 1px solid black;
    display: inline-block;
  }
  
  .sublink:hover {
    opacity: 0.7;
  }
</style>
